module.exports = __webpack_public_path__ + "img/calendar-date.20ce8a9c.svg";